import { render, staticRenderFns } from "./Better.vue?vue&type=template&id=ea4b88ae&"
import script from "./Better.vue?vue&type=script&lang=js&"
export * from "./Better.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports